import { useState, useEffect } from 'react';

const API = import.meta.env.VITE_API_BASE || '/api';
const REFRESH_MS = 10 * 60 * 1000; // 10 min; backend already caches at the same TTL

export function useBriefing(observer) {
  const [briefing, setBriefing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let timer;

    async function tick() {
      try {
        const q = (observer?.lat != null && observer?.lon != null)
          ? `?lat=${observer.lat}&lon=${observer.lon}`
          : '';
        const r = await fetch(`${API}/briefing${q}`);
        if (!r.ok) return;
        const d = await r.json();
        if (!cancelled) {
          setBriefing(d);
          setLoading(false);
        }
      } catch { /* retain last value */ }
    }

    tick();
    timer = setInterval(tick, REFRESH_MS);
    return () => { cancelled = true; clearInterval(timer); };
  }, [observer?.lat, observer?.lon]);

  return { briefing, loading };
}